// react 
import React, { createContext, useEffect, useState } from "react";
// css
import "./App.css";
// browserrouter 
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// Components
import Header from './Component/Header';
import Footer from "./Component/Footer";
// pages
import Home from "./pages/Home";
// About pages
import AboutUs from "./pages/About/AboutUs";
import Blog from "./pages/About/Blog";
import BlogCategory from "./pages/About/BlogCategory";
import Contact from "./pages/About/Contact";
// Shop pages
import Shop from "./pages/Shop/Shop";
import ShopGridCol3 from "./pages/Shop/ShopGridCol3";
import ShopListCol from "./pages/Shop/ShopListCol";
import ShopCart from "./pages/Shop/ShopCart";
import ShopCheckOut from "./pages/Shop/ShopCheckOut";
import ShopWishList from "./pages/Shop/ShopWishList";
// Store pages
import StoreList from "./pages/store/StoreList";
import SingleShop from "./pages/store/SingleShop";
// Account pages
import MyAccountOrder from "./pages/Accounts/MyAccountOrder";
import MyAccountSetting from "./pages/Accounts/MyAcconutSetting";
import MyAcconutNotification from "./pages/Accounts/MyAcconutNotification";
import MyAcconutPaymentMethod from "./pages/Accounts/MyAcconutPaymentMethod";
import MyAccountAddress from "./pages/Accounts/MyAccountAddress";
import MyAccountForgetPassword from "./pages/Accounts/MyAccountForgetPassword";
import MyAccountSignIn from "./pages/Accounts/MyAccountSignIn";
import MyAccountSignUp from "./pages/Accounts/MyAccountSignUp";
import FAQ from "./pages/FooterElements/Faq";
import Coupons from "./pages/FooterElements/Coupons";
import Careers from "./pages/FooterElements/Careers";
import HelpCenter from "./pages/FooterElements/HelpCenter";
//Hooks
import api from './api'
import useReducerWithLocalStorage from './hooks/useReducerWithLocalStorage'
import cartReducer, {initialCartState} from './reducers/cartReducer'
import wishlistReducer, { initialWishlistState } from "./reducers/wishlistReducer";
import ShopProduct from "./pages/Shop/ShopProduct";
import OrderDetailsPage from "./pages/Accounts/OrderDetailsPage";

export const UserContext = createContext()
export const CartContext = createContext()
export const ProductsContext = createContext()
export const CategoriesContext = createContext()
export const WishlistContext = createContext()
export const websiteContext = createContext()

const App = () => {
  const [user, setUser] = useState(null)
  const [products, setProducts] = useState([])
  const [categories, setCategories] = useState([])
  const [websiteDetails, setWebsiteDetails] = useState([])
  const [cart, cartDispatch] = useReducerWithLocalStorage(cartReducer,initialCartState,"cart")
  const [wishlist, wishlistDispatch] = useReducerWithLocalStorage(wishlistReducer,initialWishlistState,"whishlist")

  useEffect(() => {
    (async () => {
      const resp = await api.fetchUserDetails()
      console.log(resp)
      if (resp.status == "ok") {
        setUser(resp.user)
      }
    })()
  }, [])

  	useEffect(() => {
		(async () => {
			const resp = await api.fetchProducts("",true)
			console.log("products",resp)
			if (resp.status !== "error") {
				setProducts(resp)
			}
		})
		()
	}, [])

    useEffect(() => {
      (async () => {
        const catResp = await api.fetchCategories()
        console.log("categories",catResp)
        if (catResp.status !== "error") {
          const filtered = catResp.filter((cat)=> cat.parentId == 1)
          setCategories(filtered)
        }
      })
      ()
    }, [])

    useEffect(() => {
      (async () => {
        const web = await api.getWebsiteDetails();
        console.log("website Details",web)
        if (web.status !== "error") {
          setWebsiteDetails(web);
        }
      })
      ()
    }, [])

  useEffect(() => {
    if (!user) return
    (async () => {
      const resp = await api.getUserCart()
      console.log("cart",resp)
      if (resp?.products) {
        cartDispatch({type: "SET_PRODUCTS", payload: resp.products})
      }
    })()
  }, [user])

    useEffect(() => {
    if (!user) return
    (async () => {
      const resp = await api.getUserCart()
      if (resp?.wishlistProducts) {
        wishlistDispatch({type: "SET_PRODUCTS_LIST", payload: resp.wishlistProducts})
      }
    })()
  }, [user])
  
  return (
    <div>
      <Router>
        <websiteContext.Provider value={{websiteDetails, setWebsiteDetails}}>
        <CartContext.Provider value={{cart, cartDispatch}}>
        <UserContext.Provider value={{user, setUser}}>
        <ProductsContext.Provider value={{products, setProducts}}>
        <CategoriesContext.Provider value={{categories, setCategories}}>
        <WishlistContext.Provider value={{wishlist, wishlistDispatch}}>
          
        <Header/>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Shop pages */}
          <Route path="/Shop" element={<Shop />} />
          <Route path="/ShopProduct" element={<ShopProduct />} />
          <Route path="/ShopGridCol3" element={<ShopGridCol3 />} />
          <Route path="/ShopListCol" element={<ShopListCol />} />
          <Route path="/ShopWishList" element={<ShopWishList />} />
          <Route path="/ShopCheckOut" element={<ShopCheckOut />} />
          <Route path="/ShopCart" element={<ShopCart />} />
          {/* Store pages */}
          <Route path="/StoreList" element={<StoreList />} />
          <Route path="/SingleShop" element={<SingleShop />} />
          {/* Accounts pages */}
          <Route path="/OrderDetails" element={<OrderDetailsPage />} />
          <Route path="/MyAccountOrder" element={<MyAccountOrder />} />
          <Route path="/MyAccountSetting" element={<MyAccountSetting />} />
          <Route path="/MyAcconutNotification" element={<MyAcconutNotification />} />
          <Route path="/MyAcconutPaymentMethod" element={<MyAcconutPaymentMethod />} />
          <Route path="/MyAccountAddress" element={<MyAccountAddress />} />
          <Route path="/MyAccountForgetPassword" element={<MyAccountForgetPassword />} />
          <Route path="/MyAccountSignIn" element={<MyAccountSignIn />} />
          <Route path="/MyAccountSignUp" element={<MyAccountSignUp />} />
          {/* About pages */}
          <Route path="/Blog" element={<Blog />} />
          <Route path="/BlogCategory" element={<BlogCategory />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          {/* Footer Elements */}
          <Route path="/Faq" element={<FAQ />} />
          <Route path="/Coupons" element={<Coupons />} />
          <Route path="/Careers" element={<Careers />} />
          <Route path="/helpcenter" element={<HelpCenter />} />
        </Routes>
        <Footer/>
        </WishlistContext.Provider>
        </CategoriesContext.Provider>
        </ProductsContext.Provider>
        </UserContext.Provider>
        </CartContext.Provider>
        </websiteContext.Provider>
      </Router>
    </div>
  );
};

export default App;
